import { IconButton } from '@mui/material';
import styled from 'styled-components';

export const GeoLocationIcon = styled(IconButton)`
  margin-top: -${({ theme }) => theme.spacing(0.5)}px;
  margin-left: -${({ theme }) => theme.spacing(0.5)}px;
`;
